import React from "react";
import "./Portfolio.css";

const projects = [
  {
    title: "Devis Toiture 76",
    url: "https://devis-toiture-76.fr",
    image: "/portfolio/devis-toiture-76.png",
    description: `
      Site vitrine et génération de leads pour artisans couvreurs en Seine-Maritime.
      Développement Laravel sur-mesure avec formulaire de demande de devis, optimisation SEO locale, intégration Google Maps et gestion simplifiée des contacts.
    `,
    stack: [
      "Laravel",
      "Javascript",
      "SEO",
      "Formulaire avancé",
      "Google Maps",
      "Backend",
      "Frontend",
    ],
    year: 2023,
  },
  {
    title: "Landing Page d’adhésion pour l’arabe algérien",
    url: "https://limbaaudio.com/darjia-algerien.htm", // à remplacer par l’URL réelle si en ligne
    image: "/portfolio/landing_page.jpg", // capture d’écran à placer dans /public/portfolio/
    description: `
    Création d’une landing page moderne et optimisée pour promouvoir une offre d’adhésion à l’apprentissage de l’arabe algérien. 
    La page a été structurée selon les meilleures pratiques du marketing digital, avec une expérience utilisateur fluide et responsive grâce à HTML5, CSS3 et Bootstrap.
  `,
    stack: ["HTML5", "CSS3", "Bootstrap", "Landing Page", "Français"],
    year: 2024,
    details: `
    **Au-dessus de la ligne de flottaison :**
    - Titre principal accrocheur
    - Sous-titre explicatif
    - Bouton d’appel à l’action (CTA) visible
    - Preuve sociale (témoignages, logos, avis)
    - Visuel attractif et épuré

    **Sous la ligne de flottaison :**
    - Présentation détaillée de la méthode pédagogique
    - Section commentaires et témoignages d’apprenants
    - Foire aux questions (FAQ) pour lever les objections
    - Second appel à l’action pour maximiser la conversion
    - Présentation du créateur et de ses compétences

    **Livrables :**
    - Code HTML5 et CSS3 propre et bien commenté
    - Intégration Bootstrap pour le responsive
    - Contenu rédigé en français
    - Optimisation pour la conversion et le SEO
  `,
  },
  {
    title: "Sublime Forme – Boutique Shopify",
    url: "LIEN_DE_LA_BOUTIQUE", // Remplace par l’URL réelle si disponible
    image: "/portfolio/sublime_form.jpg", // Capture d’écran à placer dans /public/portfolio/
    description: `
    Boutique e-commerce élégante et intuitive développée sur Shopify pour Sublime Form. 
    Utilisation du thème Story, entièrement personnalisé pour refléter l’identité de la marque et optimiser l’expérience utilisateur. 
    Le site propose un parcours d’achat fluide, une navigation mobile optimisée et des pages produits conçues pour maximiser la conversion.
  `,
    stack: ["Shopify", "Liquid", "JavaScript", "SEO Content", "UI Graphics"],
    year: 2024,
    details: `
    **Rôle :** Web Designer

    **Fonctionnalités clés :**
    - Personnalisation avancée du thème Story pour un rendu unique et professionnel
    - Optimisation des pages produits pour l’engagement et la conversion
    - Processus de commande sécurisé et simplifié
    - Design responsive, rapide et adapté à tous les supports (mobile, tablette, desktop)
    - Création de contenus optimisés pour le SEO
    - Réalisation de visuels graphiques pour renforcer l’identité de marque

    **Livrables :**
    - Code Liquid personnalisé
    - Intégration JavaScript pour des fonctionnalités avancées
    - Optimisation SEO on-page
    - Design UI/UX moderne et épuré
  `,
  },
  {
    title: "Nova Solution",
    url: "https://novasolution.fr",
    image: "/portfolio/novasolution.png",
    description: `
    Site vitrine développé sous WordPress pour Nova Solution, une entreprise spécialisée dans les solutions technologiques. 
    Le site met en avant une présentation claire des services, une navigation intuitive et un design moderne et professionnel.
    L’objectif principal était de créer une plateforme facile à gérer pour le client, tout en assurant une expérience utilisateur fluide et responsive.
  `,
    stack: [
      "WordPress",
      "Elementor",
      "PHP",
      "HTML5",
      "CSS3",
      "JavaScript",
      "SEO",
    ],
    year: 2025,
    details: `
    **Rôle :** Développeur Web / Intégrateur WordPress

    **Fonctionnalités clés :**
    - Intégration et personnalisation d’un thème WordPress adapté à la charte graphique de Nova Solution
    - Mise en place d’un système de gestion de contenu simple pour permettre au client de modifier textes et images facilement
    - Optimisation du site pour le référencement naturel (SEO) avec balises meta et structure sémantique
    - Design responsive garantissant une expérience optimale sur mobiles, tablettes et desktops
    - Ajout de modules personnalisés pour les formulaires de contact et sections dynamiques
    - Amélioration des performances et temps de chargement pour une meilleure expérience utilisateur

    **Livrables :**
    - Thème WordPress personnalisé
    - Plugins configurés et adaptés aux besoins du client
    - Documentation pour la gestion du site par le client
    - Optimisation SEO on-page et bonnes pratiques de développement
  `,
  },
  {
    title: "Inliso Mobilite",
    url: "https://inliso-mobilite.fr",
    image: "/portfolio/inliso-mobilite-fr.png",
    description: `
    Plateforme web dédiée à la gestion de la mobilité professionnelle et personnelle, connectée à l'écosystème Zoho pour une automatisation complète des processus métiers.
  `,
    stack: ["Zoho API", "ZohoCRM", "Laravel", "NextJS"],
    year: 2025,
    details: `
    **Rôle :** Développeur Fullstack

    **Contexte du projet :**
    Construction complète d'un site vitrine en une plateforme dynamique et connectée, avec une forte intégration CRM pour gérer les leads, les contacts et les opportunités commerciales.

    **Livrables & Réalisations :**
    - Intégration fidèle d’une maquette FIGMA réalisée par un designer UX/UI
    - Développement d’une passerelle personnalisée entre Laravel et ZohoCRM via les API REST Zoho
    - Synchronisation bidirectionnelle des données entre ZohoCRM et la base de données Laravel
    - Création de modules spécifiques pour la gestion des formulaires de contact, des demandes de devis et du suivi client
    - Implémentation des appels API sécurisés avec gestion des tokens d’authentification Zoho
    - Rendu SSR (Server Side Rendering) avec NextJS pour des performances optimales et une meilleure indexation SEO
    - Déploiement et mise en production sur un hébergement sécurisé avec optimisation des performances backend/frontend

    **Résultat :**
    Une plateforme moderne, rapide et totalement connectée à l’environnement Zoho, permettant une automatisation efficace des processus commerciaux et une interface utilisateur claire et responsive.
  `,
  },
];

const Portfolio = () => (
  <section className="portfolio-section">
    <h2>🖼️ Portfolio</h2>
    <div className="portfolio-grid">
      {projects.map((project, idx) => (
        <div className="portfolio-card" key={idx}>
          <a href={project.url} target="_blank" rel="noopener noreferrer">
            <img
              src={project.image}
              alt={`Capture du site ${project.title}`}
              className="portfolio-image"
              loading="lazy"
            />
          </a>
          <div className="portfolio-content">
            <h3>{project.title}</h3>
            <p className="portfolio-desc">{project.description}</p>
            <div className="portfolio-stack">
              {project.stack.map((tech, i) => (
                <span className="portfolio-badge" key={i}>
                  {tech}
                </span>
              ))}
            </div>
            <a
              href={project.url}
              target="_blank"
              rel="noopener noreferrer"
              className="portfolio-link"
            >
              Voir le site
            </a>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default Portfolio;
